export const logError = (error, info) => {
    // Do something with the error, e.g. log to an external API
    console.log('=======ERORR=========', error, '------info------', info);
};